import { useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import KindOfFlightCard from '../FlightCard/KindOfFlightCard';
import FlightScaleRow from '../FlightCard/FlightScaleRow';
import IndicateScaleCard from '../FlightCard/IndicateScaleCard';

const ColorButton = styled(Button)({
  color: '#3A3A3A',
  backgroundColor: 'transparent',
  '&:hover': {
    color: '#444',
  },
});

const DialogStyles = {
  title: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 auto auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 5px 16px 2rem',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '0 0 2rem 0',
    maxHeight: { sm: 'inherit', lg: 600 },
    overflow: { sm: 'inherit' },
    alignSelf: 'center',
    width: { xs: '100%' },
  },
};

const FlightSingleDetailDialog = ({ flight, kind, originId, destinationId, scales, duration }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const validScales = useMemo(() => scales.filter((scale) => !scale.isNotScale), [scales]);

  const handleToggleDialog = () => setOpen((prev) => !prev);

  const adaptSegmentToFlightFormat = (segment) => ({
    arrival: {
      city: segment.destination_city_name,
      name: segment.destination_short_name,
      country: '', // No disponible en el nuevo formato
      type: segment.destination_type,
    },
    departure: {
      city: segment.origin_city_name,
      name: segment.origin_short_name,
      country: '', // No disponible en el nuevo formato
      type: segment.origin_type,
    },
    arrivalDate: segment.arrival_date_time,
    departureDate: segment.departure_date_time,
    company: segment.company_name,
    originDestinationReferences: `${segment.origin_iata}-${segment.destination_iata}`,
  });

  return (
    <>
      <ColorButton variant="text" onClick={handleToggleDialog} size="small" color="info">
        Más Detalles
      </ColorButton>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleToggleDialog}
        aria-labelledby="flight-detail-dialog"
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: '15px',
          },
        }}
      >
        <DialogTitle sx={DialogStyles.title}>
          <Typography fontSize={24} fontWeight={700}>
            Detalle de vuelo
          </Typography>
          <Button onClick={handleToggleDialog}>
            <CloseIcon style={{ fill: '#000' }} />
          </Button>
        </DialogTitle>

        <DialogContent sx={DialogStyles.content}>
          <KindOfFlightCard
            isVueloDeIda={kind === 'ida'}
            isVueloDeVuelta={kind === 'vuelta'}
            originId={originId}
            destinationId={destinationId}
            duration={duration}
          />

          {flight.map((segment, index) => {
            const adaptedSegment = adaptSegmentToFlightFormat(segment);
            return (
              <div key={`flight-segment-${index}`}>
                <FlightScaleRow {...adaptedSegment} />
                {index < flight.length - 1 && validScales[index] && (
                  <IndicateScaleCard info={validScales[index]} key={index} />
                )}
              </div>
            );
          })}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FlightSingleDetailDialog;
